import { emptyString, NULL_DATA_HYPHEN } from "../../constants";

/**
 * Convert a label to a kebab-case slug for data-testid attributes.
 */
export const toTestIdSlug = (label = emptyString) =>
  String(label).toLowerCase().replace(/\s+/g, NULL_DATA_HYPHEN);

/**
 * Build a data-testid from a prefix, label slug, and optional suffix.
 * e.g. buildTestId("progress-card", "Surveys Opened", "value")
 *   → "progress-card-surveys-opened-value"
 */
export const buildTestId = (prefix, label, suffix) => {
  const slug = toTestIdSlug(label);
  if (suffix) {
    return `${prefix}${NULL_DATA_HYPHEN}${slug}${NULL_DATA_HYPHEN}${suffix}`;
  }
  return `${prefix}${NULL_DATA_HYPHEN}${slug}`;
};
